<div class="page-container">
    <app-header [title]="title"></app-header>
    <app-breadcrumbs></app-breadcrumbs>
    <main class="content-wrap">
        <router-outlet />
    </main>
    <app-footer></app-footer>
</div>
